const SABT_HYPOS = [
    {
        seg: "TRUST PROOF",
        kind: "trust",
        title: "Add review proof above the buy button",
        varB: ["4.8★ from 2,140 reviews", "Three real customer photos", "“Ships in 24h” guarantee"],
        primary: "Checkout starts",
        aVal: "23.4%",
        bVal: "27.7%",
        aFill: 66,
        bFill: 80,
        lift: "+18.4%",
        visitors: "2,480",
        confidence: "98%",
        signals: [
            { n: "Checkout starts", d: "+18.4%", up: true },
            { n: "Add to cart", d: "+11.1%", up: true },
            { n: "Scroll to offer", d: "+6.2%", up: true },
            { n: "Refund rate", d: "no change", up: null },
        ],
        verdict: "Variant B wins. Proof next to the offer lifted checkout starts at 98% confidence — and add-to-cart moved with it. Safe to ship.",
        nextStep: "Pin a “Ships in 24h” badge to the mobile cart and re-test.",
        by: "Mai — CRO specialist",
        initials: "M",
    },
    {
        seg: "OFFER",
        kind: "offer",
        title: "Lead with the 3-pack bundle",
        varB: ["Bundle selected by default", "“Save 22%” value badge", "Per-unit price shown"],
        primary: "Add to cart",
        aVal: "8.9%",
        bVal: "10.0%",
        aFill: 58,
        bFill: 70,
        lift: "+12.1%",
        visitors: "3,120",
        confidence: "96%",
        signals: [
            { n: "Add to cart", d: "+12.1%", up: true },
            { n: "Avg order value", d: "+19%", up: true },
            { n: "Revenue / visitor", d: "+14%", up: true },
            { n: "Conversion", d: "no change", up: null },
        ],
        verdict: "Variant B wins. Defaulting to the bundle raised order value with no drop in conversion. Ship it.",
        nextStep: "Add a 5-pack tier to see how far the value framing scales.",
        by: "Diego — Growth analyst",
        initials: "D",
    },
    {
        seg: "VALUE CLARITY",
        kind: "value",
        title: "Swap the spec list for 3 outcomes",
        varB: ["Three benefit-led lines", "Plain-language copy", "One icon per outcome"],
        primary: "Scroll to offer",
        aVal: "41.0%",
        bVal: "45.0%",
        aFill: 72,
        bFill: 82,
        lift: "+9.7%",
        visitors: "2,905",
        confidence: "95%",
        signals: [
            { n: "Scroll to offer", d: "+9.7%", up: true },
            { n: "Time on page", d: "+8%", up: true },
            { n: "Checkout starts", d: "+5.4%", up: true },
            { n: "Bounce rate", d: "no change", up: null },
        ],
        verdict: "Variant B wins. Outcome-led copy moved more visitors to the offer and lifted checkout starts downstream. Clear, repeatable lift.",
        nextStep: "Carry the same outcome framing into the PDP hero next.",
        by: "Sara — Conversion lead",
        initials: "S",
    },
]

const SABT_STEPS = ["Pick a section", "Two hypotheses", "Measure conversion", "Expert verdict", "Ship & repeat"]

const SABT_PRODUCT = { name: "Aurora Glow Serum", price: "$48", image: window.SABT?.assets?.product };

const SABT_CONFIG = {
    autoplay: {
        stepDelay: 4400, // delay giữa các step
        loopDelay: 3400, // delay từ step 5 -> hypo mới
    }
};

const AB_Testing = {
    step: 0,
    hypo: 0,
    kind: 'trust',

    init() {
        this.Header.buildSteps(SABT_STEPS);

        this.contentHolder = document.getElementById('js-ab-content-holder');
        this.panelHolder = document.getElementById("js-ab-panel");
        this.stageEl = document.querySelector('#js-ab-testing-stage');

        this.kind = SABT_HYPOS[this.hypo]?.kind || SABT_HYPOS[0].kind; // đồng bộ kind theo hypo hiện tại

        this.render();

        this.AutoPlay.init(this);
    },

    render() {
        this.Header.renderSteps(this.step);

        this.renderContent();

        this.renderPanel();
    },

    getCurrentHypo() {
        return SABT_HYPOS[this.hypo] || SABT_HYPOS[0];
    },

    renderContent() {
        const { step, Content, contentHolder } = this;
        const data = this.getCurrentHypo();

        switch (step) {
            case 0:
                contentHolder.innerHTML = Content.mockContent(data);
                break;

            case 1:
            case 2:
                contentHolder.innerHTML = Content.renderCompareMock(data.kind);
                break;

            case 3:
                contentHolder.innerHTML = Content.renderCompareMock(data.kind, true);
                break;

            case 4:
                contentHolder.innerHTML = Content.mockContent(data, true);
                break;
        }
    },

    renderPanel() {
        const {
            step,
            Panel,
            panelHolder,
            events
        } = this;

        const data = this.getCurrentHypo();

        switch (step) {
            case 0:
                panelHolder.innerHTML = Panel.renderPickSection();
                events.bindPickSection(this);
                break;

            case 1:
                panelHolder.innerHTML = Panel.renderHypothesis(data);
                break;

            case 2:
                panelHolder.innerHTML = Panel.renderMeasure(data);
                break;

            case 3:
                panelHolder.innerHTML = Panel.renderVerdict(data);
                events.bindShipStep(this);
                break;

            case 4:
                panelHolder.innerHTML = Panel.renderShip(data);
                break;
        }
    },

    goToStep(step, options = {}) {
        const { keepAuto = true } = options;
        const maxStep = SABT_STEPS.length - 1;

        this.step = Math.max(0, Math.min(step, maxStep));
        this.render();

        if (keepAuto) {
            this.AutoPlay.restart();
        }
    },

    goToHypo(hypoIndex, step = 0, options = {}) {
        const { keepAuto = false } = options;
        const total = SABT_HYPOS.length;
        const safeIndex = ((hypoIndex % total) + total) % total;
        const data = SABT_HYPOS[safeIndex];

        if (!data) return;

        this.hypo = safeIndex;
        this.kind = data.kind;
        this.step = step;

        this.render();

        if (keepAuto) {
            this.AutoPlay.restart();
        }
    },

    Header: {
        buildSteps(steps) {
            const target = document.getElementById('js-ab-steps');

            target.innerHTML = steps.map((item, index) => `
                <button
                    class="js-ab-step-item sabt__step ${index === AB_Testing.step ? 'is-active' : ''}"
                    data-step="${index}">
                    <span class="sabt__step-n">${String(index + 1).padStart(2, '0')}</span>
                    <span class="sabt__step-t">${item}</span>
                </button>
            `).join('');

            this.stepItems = [...target.querySelectorAll('.js-ab-step-item')];
            this.stepNumbers = this.stepItems.map(item => item.querySelector('.sabt__step-n'));

            this.stepItems.forEach(item => {
                item.addEventListener('click', () => {
                    AB_Testing.goToStep(Number(item.dataset.step));
                });
            });
        },

        renderSteps(step) {
            this.stepItems.forEach((item, index) => {
                item.classList.toggle('is-active', index === step);
                item.classList.toggle('is-done', index < step);

                this.stepNumbers[index].innerHTML =
                    index < step
                        ? Icon.check({ style: { width: 12, height: 12 } })
                        : String(index + 1).padStart(2, '0');
            });
        }
    },

    // Col-left
    Content: {
        mockContent(data, isFinal = false) {

            const checkHead = isFinal
                ? `<span class="sabt__shipped" style="margin-top: 0px;">
                        ${Icon.check()}
                        Winner live · 100%
                    </span>`
                : `<span class="sabt__pick">
                        ${Icon.columns({ width: 11, height: 11 })} 
                        A/B test this
                    </span>`;


            return `
                <div class="sabt__target sabt__swap ${isFinal ? 'is-shipped' : ''}">
                    <div class="sabt__target-in">
                        <div class="sabt__target-head">
                            <span class="sabt__target-seg" ${isFinal ? 'style="color: var(--win-soft);"' : ''}> 
                                ${data.seg} 
                            </span>
                            
                            ${checkHead}
                        </div>
                        
                        ${isFinal ? this.renderVariantContent(data.kind, "b") : this.renderMock(data.kind, "a")}
                    </div>
                </div>
            `
        },

        renderCompareMock(kind, showWinner = false) {
            return `
                <div class="sabt__target sabt__swap">
                    <div class="sabt__target-in">
                        ${this.renderMock(kind, "b", showWinner)}
                    </div>
                </div>
            `;
        },

        renderMock(kind, variant, showWinner = false) {
            if (variant === "a") {
                return this.renderVariantContent(kind, "a");
            }

            if (variant === "b") {
                const data = SABT_HYPOS.find(item => item.kind === kind);

                if (!data) return '';

                return this.renderCompareShell({
                    showWinner,
                    lift: data.lift,
                    aHtml: this.renderVariantContent(kind, "a"),
                    bHtml: this.renderVariantContent(kind, "b"),
                });
            }
        },

        renderCompareShell({ aHtml, bHtml, lift, showWinner = false }) {
            return `
                <div class="sabt__meter-cap">
                    <span>HYPOTHESIS A · 50%</span>
                    <span>HYPOTHESIS B · 50%</span>
                </div>

                <div class="sabt__meter">
                    <i class="ma" style="width: 50%;"></i>
                    <i class="mb" style="width: 50%;"></i>
                </div>

                <div class="sabt__split">
                    <div class="sabt__vcol is-a ${showWinner ? 'is-loser' : ''}">
                        <span class="sabt__vtab">
                            <span class="led"></span>A · Today
                        </span>

                        ${aHtml}
                    </div>

                    <div class="sabt__vcol is-b ${showWinner ? 'is-winner' : ''}">
                        <span class="sabt__vtab">
                            <span class="led"></span>B · New idea
                        </span>

                        ${bHtml}

                        ${showWinner ? `
                            <span class="sabt__win-flag">
                                ${Icon.check({ style: { width: 12, height: 12 } })}
                                WINNER <b>${lift}</b>
                            </span>
                        ` : ''}
                    </div>
                </div>
            `;
        },

        renderVariantContent(kind, variant) {
            if (kind === "trust") {
                return this.mockTrustContent(variant);
            }

            if (kind === "offer") {
                return this.mockOfferContent(variant);
            }

            if (kind === "value") {
                return this.mockValueContent(variant);
            }

            return "";
        },

        mockTrustContent(variant) {
            return `
                <div class="sabt__mk">
                    <div class="sabt__mk-row">
                        <span class="sabt__mk-thumb"> 
                            <img src="${SABT_PRODUCT.image}" 
                                alt="${SABT_PRODUCT.name}" 
                                width="40"
                                height="40"
                                loading="lazy"
                                decoding="async"
                            />
                        </span>
                        <div class="sabt__mk-info">
                            <span class="sabt__mk-name">${SABT_PRODUCT.name}</span>
                            <span class="sabt__mk-price">${SABT_PRODUCT.price}</span>
                        </div>
                    </div>

                    ${variant === "b" ? `
                        <div class="sabt__mk-proof">
                            <div class="sabt__mk-stars">
                                <span class="sabt__mk-star">★★★★★</span>
                                <b>4.8</b>
                                <i>2,140 reviews</i>

                                <span class="sabt__mk-verified">
                                    ${Icon.check({ style: { width: 9, height: 9 } })}
                                    Verified
                                </span>
                            </div>

                            <div class="sabt__mk-photos">
                                <img src="${window.SABT?.assets?.review1}" 
                                    alt="review1"
                                    width="40"
                                    height="40"
                                    loading="lazy"
                                    decoding="async"
                                />
                                <img src="${window.SABT?.assets?.review2}" 
                                    alt="review2"
                                    width="40"
                                    height="40"
                                    loading="lazy"
                                    decoding="async"
                                />
                                <img src="${window.SABT?.assets?.review3}" 
                                    alt="review3"
                                    width="40"
                                    height="40"
                                    loading="lazy"
                                    decoding="async"
                                />
                                <span class="sabt__mk-photo-more">+2k</span>
                            </div>

                            <span class="sabt__mk-guar">
                                ${Icon.shield({ width: 11, height: 11 })}
                                Ships in 24h · 60-day returns
                            </span>
                        </div>
                    ` : ''}
                    
                    <button class="sabt__mk-cta ${variant === "b" ? 'is-b' : ''}" type="button">Add to cart — ${SABT_PRODUCT.price}</button>
                </div>
            `;
        },

        mockOfferContent(variant) {
            if (variant === "a") {
                return `
                    <div class="sabt__mk">
                        <span class="sabt__mk-label">Choose your supply</span>
                        <div class="sabt__opt is-sel">
                            <span class="sabt__opt-dot"></span>
                            <div class="sabt__opt-main"><span class="sabt__opt-name">1 bottle</span></div>
                            <span class="sabt__opt-price">$48</span>
                        </div>
                        <div class="sabt__opt">
                            <span class="sabt__opt-dot"></span>
                            <div class="sabt__opt-main"><span class="sabt__opt-name">3-pack</span></div>
                            <span class="sabt__opt-price">$112</span>
                        </div>
                        <button class="sabt__mk-cta" type="button">Add to cart</button>
                    </div>
                `
            }
            else if (variant === "b") {
                return `
                    <div class="sabt__mk">
                        <span class="sabt__mk-label">Choose your supply</span>

                        <div class="sabt__opt">
                            <span class="sabt__opt-dot"></span>
                            <div class="sabt__opt-main">
                                <span class="sabt__opt-name">1 bottle</span>
                            </div>
                            <span class="sabt__opt-price">$48</span>
                        </div>

                        <div class="sabt__opt is-sel is-feature">
                            <span class="sabt__opt-pop">Most popular</span>
                            <span class="sabt__opt-dot"></span>
                            <div class="sabt__opt-main">
                                <span class="sabt__opt-name">
                                    3-pack<em class="sabt__opt-save">Save 22%</em>
                                </span>
                                <span class="sabt__opt-sub">$37.33 / bottle · you save $32</span>
                            </div>
                            <span class="sabt__opt-price">$112</span>
                        </div>

                        <span class="sabt__mk-guar">
                            ${Icon.check({ style: { width: 11, height: 11 } })}
                            Free shipping included
                        </span>
                        <button class="sabt__mk-cta is-b" type="button">Add 3-pack — $112</button>
                    </div>
                `
            }
        },

        mockValueContent(variant) {
            if (variant === "a") {
                return `
                    <div class="sabt__mk">
                        <span class="sabt__mk-label">Specifications</span>
                        <ul class="sabt__spec">
                            <li>2% Vitamin-C complex</li>
                            <li>15 ml airless pump</li>
                            <li>pH 5.5 · fragrance-free</li>
                            <li>Vegan · cruelty-free</li>
                        </ul>
                    </div>
                `;
            }

            return `
                <div class="sabt__mk">
                    <span class="sabt__mk-label">What you'll notice</span>

                    <ul class="sabt__out">
                        <li>
                            <span class="sabt__out-ic">${Icon.spark({ width: 11, height: 11 })}</span>
                            <span class="sabt__out-tx">
                                <b>Visibly brighter skin</b>
                                <i>in about 2 weeks</i>
                            </span>
                        </li>

                        <li>
                            <span class="sabt__out-ic">${Icon.spark({ width: 11, height: 11 })}</span>
                            <span class="sabt__out-tx">
                                <b>Absorbs in seconds</b>
                                <i>no sticky residue</i>
                            </span>
                        </li>

                        <li>
                            <span class="sabt__out-ic">${Icon.spark({ width: 11, height: 11 })}</span>
                            <span class="sabt__out-tx">
                                <b>Gentle every day</b>
                                <i>fragrance-free · vegan</i>
                            </span>
                        </li>
                    </ul>
                </div>
            `;
        }
    },

    // Col-right
    Panel: {
        renderPickSection() {
            return `
                <span class="sabt__panel-kicker">
                    <span class="n">STEP 01 / 05</span>
                </span>

                <h3 class="sabt__panel-title">Pick a hypothesis</h3>

                <div class="sabt__panel-body">
                    <div class="sabt__swap">

                        <p class="sabt__hint">
                            Don't start from a blank test. Pick a hypothesis the Expert Crew has already seen win on stores like yours.
                        </p>

                        <div class="sabt__hypos">
                            ${SABT_HYPOS.map((item, index) => `
                                <button
                                    class="js-ab-hypo sabt__hypo ${index === AB_Testing.hypo ? 'is-active' : ''}"
                                    data-hypo="${index}"
                                    data-kind="${item.kind}"
                                >
                                    <div class="sabt__hypo-top">
                                        <span class="sabt__hypo-seg">${item.seg}</span>

                                        <span class="sabt__hypo-go">
                                            ${Icon.arrow({ style: "width:13px; height:13px" })}
                                        </span>
                                    </div>

                                    <div class="sabt__hypo-title">
                                        ${item.title}
                                    </div>

                                    <div class="sabt__hypo-meta">
                                        <span class="sabt__hypo-metric">
                                            ${Icon.signal({ style: "width:11px;height:11px" })}
                                            ${item.primary}
                                        </span>

                                        <span class="sabt__hypo-avg">
                                            avg ${item.lift}
                                        </span>
                                    </div>
                                </button>
                            `).join('')}
                        </div>

                    </div>
                </div>
            `;
        },

        renderHypothesis(data) {

            const varB = data.varB.map(item => `
                    <li>
                        ${Icon.check()}
                        <span> ${item} </span>
                    </li>
                `).join('');

            return `
                <span class="sabt__panel-kicker"><span class="n">STEP 02 / 05</span></span>

                <h3 class="sabt__panel-title">Two hypotheses, head to head</h3>

                <div class="sabt__panel-body">
                    <div class="sabt__swap">
                        <p class="sabt__hint">Two hypotheses go head to head. <b>A</b> keeps your section exactly as it is today; <b>B</b> is the new idea. Omnise ships whichever converts better.</p>

                        <div class="sabt__rows">
                            <div class="sabt__row is-a">
                                <div class="sabt__row-head">
                                    <span class="sabt__row-tag"> A </span>
                                    <span class="sabt__row-name">Keep it exactly as-is</span>
                                </div>

                                <ul>
                                    <li>
                                        ${Icon.check()}
                                        Your live section today, unchanged
                                    </li>
                                </ul>
                            </div>

                            <div class="sabt__row is-b">
                                <div class="sabt__row-head">
                                    <span class="sabt__row-tag">B</span>
                                    <span class="sabt__row-name">${data.title}</span>
                                </div>

                                <ul> ${varB} </ul>
                            </div>
                        </div>
                        
                        <div class="sabt__setup">
                            <div class="sabt__setup-item">
                                <span class="sabt__setup-lab">Goal metric</span>
                                <span class="sabt__setup-val">
                                    ${data.primary}
                                </span>
                            </div>

                            <div class="sabt__setup-item">
                                <span class="sabt__setup-lab">Traffic split</span>
                                <span class="sabt__setup-val">50 / 50 · live</span>
                            </div>
                        </div>
                    </div>
                </div>
            `
        },

        renderMeasure(data) {
            return `
                <span class="sabt__panel-kicker"><span class="n">STEP 03 / 05</span></span>
                <h3 class="sabt__panel-title">Measuring conversion</h3>

                <div class="sabt__panel-body">
                    <div class="sabt__swap">
                        <p class="sabt__hint">Traffic splits 50 / 50. Omnise measures <b>${data.primary}</b> on the live section — no page-level noise.</p>

                        <div class="sabt__field" style="margin-top: 0px;">
                            <span class="sabt__field-lab">
                                <span class="sabt__dot-live"></span> ${data.primary} · live
                            </span>

                            <div class="sabt__race">
                                <div class="sabt__race-row is-a">
                                    <span class="sabt__race-tag">A</span>
                                    <span class="sabt__race-track">
                                        <span class="sabt__race-fill" 
                                            style="width: ${Number(data.aFill - 6)}%;"></span>
                                    </span>
                                    <span class="sabt__race-val">${data.aVal}</span>
                                </div>

                                <div class="sabt__race-row is-b">
                                    <span class="sabt__race-tag">B</span>
                                    <span class="sabt__race-track">
                                        <span class="sabt__race-fill sabt__race-fill--live" 
                                            style="width: ${Number(data.bFill - 12)}%;"></span>
                                    </span>
                                    <span class="sabt__race-val sabt__race-val--wait">…</span>
                                </div>
                            </div>
                        </div>

                        <div class="sabt__stats">
                            <div class="sabt__stat">
                                <span class="sabt__stat-n">${data.visitors}</span>
                                <span class="sabt__stat-l">visitors in test</span>
                            </div>

                            <div class="sabt__stat">
                                <span class="sabt__stat-n">72%</span>
                                <span class="sabt__stat-l">confidence · 95% to call it</span>
                            </div>
                        </div>

                        <div class="sabt__conf">
                            <span class="sabt__conf-fill" style="width: 72%;"></span>
                            <span class="sabt__conf-mark"></span>
                        </div>
                    </div>
                </div>
            `;
        },

        renderVerdict(data) {
            const signals = data.signals.map(item => `
                <span class="sabt__sig ${item.up ? 'is-up' : 'is-flat'}">
                    <span class="sabt__sig-n"> ${item.n} </span>
                    <span class="sabt__sig-d"> ${item.d} </span>
                </span>
                `).join('');

            return `
                <span class="sabt__panel-kicker"> <span class="n"> STEP 04 / 05</span> </span>

                <h3 class="sabt__panel-title">Expert verdict + next test</h3>

                <div class="sabt__panel-body">
                    <div class="sabt__swap">
                        <div class="sabt__result-top">
                            <span class="sabt__uplift"> ${data.lift} </span>
                            <span class="sabt__uplift-lab">
                                <b> Hypothesis B converts better </b><br>
                                ${data.primary} · ${data.confidence} confidence
                            </span>
                        </div>

                        <div class="sabt__verdict">
                            <div class="sabt__verdict-head">
                                <span class="sabt__avatar"> ${data.initials} </span>

                                <div class="sabt__verdict-who">
                                    <span class="sabt__verdict-name"> ${data.by} </span>
                                    <span class="sabt__verdict-role">
                                        ${Icon.expert({ style: { width: 11, height: 11 } })}
                                        Omnise expert · read every signal
                                    </span>
                                </div>
                            </div>

                            <div class="sabt__sigs"> ${signals} </div>

                            <p class="sabt__verdict-q"> ${data.verdict} </p>

                            <div class="sabt__next">
                                <span class="sabt__next-ic">
                                    ${Icon.arrow({ style: { width: 13, height: 13 } })}
                                </span>
                                <div>
                                    <span class="sabt__next-lab">Recommended next test</span>
                                    <span class="sabt__next-txt"> ${data.nextStep} </span>
                                </div>
                            </div>
                        </div>

                        <button class="sabt__ship" id="js-go-to-ship">
                            ${Icon.ship({ style: { width: 13, height: 13 } })}
                            <span> Ship Hypothesis B </span>
                        </button>
                    </div>
                </div>
            `;
        },

        renderShip(data) {

            const currentIndex = SABT_HYPOS.findIndex(item => item.kind === data.kind);

            const nextData = SABT_HYPOS[(currentIndex + 1) % SABT_HYPOS.length];

            const bars = [34, 48, 62, 80].map((h, i) => `
                <div class="sabt__climb-bar ${i === 3 ? 'is-now' : ''}">
                    <span class="sabt__climb-fill" style="height: ${h}%;"></span>
                    <span class="sabt__climb-x"> ${i === 3 ? 'Now' : `T${i + 1}`}</span>
                </div>
            `);

            return `
                <span class="sabt__panel-kicker"> <span class="n">STEP 05 / 05</span> </span>

                <h3 class="sabt__panel-title">Shipped → keep improving</h3>

                <div class="sabt__panel-body">
                    <div class="sabt__swap">
                        <span class="sabt__loop-badge">
                            ${Icon.check({ style: { width: 14, height: 14 } })}
                            Winner live · 100% of traffic
                        </span>

                        <div class="sabt__climb">
                            <div class="sabt__climb-head">
                                <span class="sabt__field-lab" style="margin: 0px;"> Store conversion rate </span>
                                <span class="sabt__climb-delta">
                                    ${Icon.trend({ style: { width: 13, height: 13 } })}
                                    2.1% → 2.9%
                                </span>
                            </div>

                            <div class="sabt__climb-bars">
                                ${bars}
                                <div class="sabt__climb-bar is-next">
                                    <span class="sabt__climb-fill" style="height: 92%;"></span>
                                    <span class="sabt__climb-x">Next</span>
                                </div>
                            </div>
                        </div>
                        
                        <div class="sabt__queued">
                            <span class="sabt__queued-lab">
                                ${Icon.loop()}
                                Next hypothesis · already queued
                            </span>
                            
                            <div class="sabt__queued-card">
                                <span class="sabt__queued-seg">${nextData.seg}</span>
                                <span class="sabt__queued-title">${nextData.title}</span>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }
    },

    AutoPlay: {
        timer: null,
        running: false,
        hovering: false,
        inView: false,
        observer: null,

        stepDelay: SABT_CONFIG?.autoplay?.stepDelay ?? 3000,
        loopDelay: SABT_CONFIG?.autoplay?.loopDelay ?? 3000,

        startedAt: 0,
        currentDelay: 0,
        remaining: 0,

        init(ctx) {
            this.ctx = ctx;

            if (!ctx.stageEl) return;

            ctx.stageEl.addEventListener('mouseenter', () => {
                this.hovering = true;
                this.pause();
            });

            ctx.stageEl.addEventListener('mouseleave', () => {
                this.hovering = false;
                this.resume();
            });

            this.initObserver();
        },

        initObserver() {
            if (!this.ctx?.stageEl) return;

            this.observer = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0];
                    this.inView = !!entry?.isIntersecting;

                    if (!this.shouldAutoPlay()) {
                        this.stop();
                        return;
                    }

                    if (this.inView) {
                        if (!this.running) {
                            this.start();
                        } else if (!this.hovering) {
                            this.resume();
                        }
                    } else {
                        this.pause();
                    }
                },
                {
                    threshold: 0.35
                }
            );

            this.observer.observe(this.ctx.stageEl);
        },

        shouldAutoPlay() {
            return !window.matchMedia('(max-width: 1023px)').matches;
        },

        getDelay() {
            return this.ctx.step === SABT_STEPS.length - 1
                ? this.loopDelay
                : this.stepDelay;
        },

        syncCssDuration(delay = this.getDelay()) {
            if (!this.ctx.stageEl) return;
            this.ctx.stageEl.style.setProperty('--sabt-dur', `${delay}ms`);
        },

        clear() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        },

        start() {
            if (!this.shouldAutoPlay() || !this.inView) return;

            this.running = true;
            this.clear();
            this.schedule();
        },

        stop() {
            this.running = false;
            this.clear();
            this.remaining = 0;
        },

        restart() {
            if (!this.running || !this.inView || !this.shouldAutoPlay()) return;

            this.clear();
            this.remaining = 0;

            if (this.hovering) return;

            this.schedule();
        },

        schedule(delay = this.getDelay()) {
            if (!this.running || this.hovering || !this.inView || !this.shouldAutoPlay()) return;

            this.currentDelay = delay;
            this.remaining = delay;
            this.startedAt = Date.now();

            this.syncCssDuration(delay);

            this.timer = setTimeout(() => {
                this.timer = null;
                this.next();
            }, delay);
        },

        pause() {
            if (!this.running || !this.timer) return;

            const elapsed = Date.now() - this.startedAt;
            this.remaining = Math.max(this.currentDelay - elapsed, 0);

            this.clear();
        },

        resume() {
            if (
                !this.running ||
                this.timer ||
                this.hovering ||
                !this.inView ||
                !this.shouldAutoPlay()
            ) return;

            const delay = this.remaining > 0 ? this.remaining : this.getDelay();
            this.schedule(delay);
        },

        next() {
            if (!this.running || !this.inView) return;

            const lastStep = SABT_STEPS.length - 1;

            if (this.ctx.step < lastStep) {
                this.ctx.step += 1;
                this.ctx.render();
                this.schedule();
                return;
            }

            const nextHypo = (this.ctx.hypo + 1) % SABT_HYPOS.length;
            this.ctx.goToHypo(nextHypo, 0, { keepAuto: false });
            this.schedule();
        }
    },

    events: {
        bindPickSection(ctx) {
            const hypos = ctx.panelHolder.querySelectorAll(".js-ab-hypo");

            hypos.forEach(btn => {
                btn.addEventListener("click", () => {
                    ctx.goToHypo(Number(btn.dataset.hypo), 0);
                    ctx.AutoPlay.restart();
                });
            });
        },

        bindShipStep(ctx) {
            const btn = ctx.panelHolder.querySelector('#js-go-to-ship');
            if (!btn) return;

            btn.addEventListener('click', () => {
                ctx.goToStep(4, { keepAuto: false });
                ctx.AutoPlay.restart();
            });
        }

    }
}

const renderAttrs = (p) => {
    if (!p) return '';
    return Object.entries(p).map(([k, v]) => {
        if (k === 'style' && typeof v === 'object' && v !== null) {
            const styleStr = Object.entries(v)
                .map(([sk, sv]) => `${sk.replace(/[A-Z]/g, m => `-${m.toLowerCase()}`)}: ${sv}`)
                .join('; ');
            return `${k}="${styleStr}"`;
        }
        return `${k}="${v}"`;
    }).join(' ');
};

const Icon = {
    flask: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M9 3h6"/><path d="M10 3v6L4 19a2 2 0 0 0 1.7 3h12.6A2 2 0 0 0 20 19l-6-10V3"/><path d="M6.5 14h11"/></svg>
    `,

    columns: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M12 4v16"/><rect x="3" y="5" width="6" height="14" rx="1.5"/><rect x="15" y="5" width="6" height="14" rx="1.5"/></svg>
    `,

    arrow: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
    `,

    check: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M20 6 9 17l-5-5"/></svg>
    `,

    ship: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M12 19V8"/><path d="m6 12 6-6 6 6"/><path d="M5 21h14"/></svg>
    `,

    loop: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M21 12a9 9 0 1 1-3-6.7"/><path d="M21 4v5h-5"/></svg>
    `,

    shield: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M12 3 5 6v5c0 4.3 2.9 8.2 7 9.4 4.1-1.2 7-5.1 7-9.4V6l-7-3Z"/><path d="m9.5 12 1.7 1.7 3.3-3.4"/></svg>
    `,

    trend: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="m4 16 5-5 4 4 7-8"/><path d="M16 7h5v5"/></svg>
    `,

    expert: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><circle cx="12" cy="8" r="3.4"/><path d="M5.5 20a6.5 6.5 0 0 1 13 0"/><path d="m15.5 9.4 1.4 1.4 2.4-2.6"/></svg>
    `,

    signal: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M4 20V10M9 20V4M14 20v-7M19 20v-12"/></svg>
    `,

    spark: (p) => `
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" ${renderAttrs(p)}><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8"/></svg>
    `,

};


document.addEventListener('DOMContentLoaded', () => {
    const stage = document.querySelector('#js-ab-testing-stage');
    if (!stage) return;

    let hasInited = false;

    const observer = new IntersectionObserver(
        (entries) => {
            const entry = entries[0];

            if (!entry?.isIntersecting || hasInited) return;

            hasInited = true;
            AB_Testing.init();
            observer.unobserve(stage);
        },
        {
            threshold: 0.2
        }
    );

    observer.observe(stage);
});